import useGlobalContext from '../../hooks/useGlobalContext';
import {useNavigate} from 'react-router';
import clientList from '../../json/carouselClients.json';
import Carousel from '../components/carousel';

const Clients = () => {
  const {setContactFormParams} = useGlobalContext();
  const navigate = useNavigate();
  
  const goContact = () => {
    setContactFormParams ({message:'Deseo conocer más sobre SITEV y sus planes de licenciamiento'});
    navigate('/contact');
  };

  return (
    <section className="clients-section" id="clients">
    
      <div className="clients-container">
        <div className="clients-container2">
          <h2 className="clients__subtitle">Nuestros Clientes</h2>
          <p className="clients__details">
            SITEV se utiliza en más de 75 líneas de inspección técnica vehicular a nivel nacional.
            <br/>
            Estos son algunos de nuestros casos de éxito:
          </p>
          <Carousel listImages={clientList} enableTimer={false} height={"h-200"}/>

          <button className="clients__button-contact" id="clients__button-contact" onClick={goContact}>
            Contáctenos para saber más de SITEV<br/>y sus planes de licenciamiento
          </button>
        </div>
        
      </div>
    </section>
  )
}
 
export default Clients;